const sleep = (sleepTime: number) =>
  new Promise((res) => {
    setTimeout(() => res(''), sleepTime);
  });

export default sleep;
